/** Public contact details shown in the web app (footer, contact page, etc.) */
export const CONTACT_EMAIL = 'contact@tajabazzar.me';
export const CONTACT_PHONE = '+1 438 619 6543';
export const CONTACT_PHONE_TEL = 'tel:+14386196543';
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;
export const CONTACT_ADDRESS_LINE1 = 'Biratnagar, Morang';
export const CONTACT_ADDRESS_LINE2 = 'Province 1, Nepal';

export const SOCIAL_LINKS = {
  facebook: 'https://facebook.com/saskreetbhattarai62',
  instagram: 'https://instagram.com/saskreet_bhattarai',
  twitter: 'https://twitter.com/tajabazzar',
};
